export const MODAL_TRANSITION_DURATION = 240;
const COMMON_SMALL_MODAL_CONTENT_TRANSITION_STYLES = {
    transform: `translate3d(0,-24px,0)`,
    transition: `transform ${MODAL_TRANSITION_DURATION}ms cubic-bezier(.4,.14,1,1)`,
};
const getBaseModalContentStyles = (theme) => {
    const MARGIN = `${theme.space.xxl}px`;
    return {
        large: {
            height: '100vh',
            marginLeft: MARGIN,
            overflowY: 'hidden',
            transform: 'translateX(100%)',
            transition: `transform ${MODAL_TRANSITION_DURATION}ms ease-in-out`,
        },
        small: Object.assign({ maxHeight: '100vh', overflow: 'auto', margin: MARGIN }, COMMON_SMALL_MODAL_CONTENT_TRANSITION_STYLES),
    };
};
const afterOpenModalContentStyles = {
    large: {
        transform: 'translateX(0)',
    },
    small: {
        height: 'auto',
        transform: `translateZ(0)`,
        transition: `transform ${MODAL_TRANSITION_DURATION}ms cubic-bezier(0,0,.3,1)`,
    },
};
const beforeCloseModalContentStyles = {
    large: {
        transform: 'translateX(100%)',
    },
    small: COMMON_SMALL_MODAL_CONTENT_TRANSITION_STYLES,
};
export const getChocoModalContentStyles = ({ css, theme, size, cx: classNames, overrideBaseStyles, }) => {
    const sizedBaseModalStyles = getBaseModalContentStyles(theme)[size];
    return {
        base: classNames(css([
            Object.assign({ backgroundColor: theme.colors.neutralBg, boxSizing: 'border-box' }, overrideBaseStyles),
            sizedBaseModalStyles,
        ])),
        afterOpen: classNames(css(afterOpenModalContentStyles[size])),
        beforeClose: classNames(css(beforeCloseModalContentStyles[size])),
    };
};
const COMMON_SMALL_MODAL_OVERLAY_TRANSITION_STYLES = {
    opacity: 0,
    transition: `opacity ${MODAL_TRANSITION_DURATION}ms cubic-bezier(.4,.14,1,1),visibility 0ms linear ${MODAL_TRANSITION_DURATION}ms`,
    visibility: 'hidden',
};
const baseOverlayStyles = {
    large: {
        alignItems: 'flex-end',
        opacity: 0,
        transition: `opacity ${MODAL_TRANSITION_DURATION}ms ease-in-out`,
    },
    small: Object.assign({ alignItems: 'center', justifyContent: 'center' }, COMMON_SMALL_MODAL_OVERLAY_TRANSITION_STYLES),
};
const afterOpenOverlayStyles = {
    large: { opacity: 1 },
    small: {
        opacity: 1,
        transition: `opacity ${MODAL_TRANSITION_DURATION}ms cubic-bezier(0, 0,.3, 1), visibility 0ms linear`,
        visibility: 'inherit',
    },
};
const beforeCloseOverlayStyles = {
    large: { opacity: 0 },
    small: COMMON_SMALL_MODAL_OVERLAY_TRANSITION_STYLES,
};
export const getOverlayStyles = ({ css, theme, size, cx: classNames, }) => {
    return {
        base: classNames(css([
            {
                position: 'fixed',
                backgroundColor: theme.colors.neutralBgWeakInverted,
                bottom: 0,
                left: 0,
                right: 0,
                top: 0,
                display: 'flex',
                flexDirection: 'column',
                zIndex: theme.zIndices.modalOverlay,
            },
            baseOverlayStyles[size],
        ])),
        afterOpen: classNames(css(afterOpenOverlayStyles[size])),
        beforeClose: classNames(css(beforeCloseOverlayStyles[size])),
    };
};
//# sourceMappingURL=data:application/json;base64,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